var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75 3.75C3.08696 3.75 2.45107 4.01339 1.98223 4.48223C1.51339 4.95107 1.25 5.58696 1.25 6.25V13.75C1.25 14.413 1.51339 15.0489 1.98223 15.5178C2.45107 15.9866 3.08696 16.25 3.75 16.25H10.625C11.288 16.25 11.9239 15.9866 12.3928 15.5178C12.8616 15.0489 13.125 14.413 13.125 13.75V6.25C13.125 5.58696 12.8616 4.95107 12.3928 4.48223C11.9239 4.01339 11.288 3.75 10.625 3.75H3.75ZM16.6167 15.625L14.375 13.3833V6.61667L16.6167 4.375C17.4033 3.5875 18.75 4.145 18.75 5.25833V14.7417C18.75 15.855 17.4033 16.4125 16.6167 15.625Z",
    fill: "#8A8A99"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.3002bedf603482be87b94b963d66c9a0.svg";
export { ForwardRef as ReactComponent };